import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BackendState, BackendStore } from './backend.store';

@Injectable({
  providedIn: 'root',
})
export class BackendQuery extends Query<BackendState> {
  servicePause$ = this.select((state) => state.servicePause);
  online$ = this.select((state) => state.online);

  constructor(protected store: BackendStore) {
    super(store);
  }
}
